export const getInputNameByQuestion = (questions) => {
	const result = {};
	const schemaObj = {
		Nombre: "name",
		Correo: "email",
		Teléfono: "phone",
		Email: "email",
	};
	questions.forEach((el) => {
		result[schemaObj[el.question]] = el.answer;
	});
	return result;
};
